module.exports = __webpack_public_path__ + "static/img/bottom@2x.7e004c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK_min/bottom@2x.png
// module id = 6C/n
// module chunks = 69